
import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    JoditEditor
} from '../../ui/ot'
import axios from 'axios';

const language_culture_code = 'zh-tw'
const QuestionAndAnswerForm = ({
    propsForm,
    field,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    defaultValue = {}

}) => {
    const [form] = Form.useForm();
    const [count, setCount] = useState(0);
    const editor = useRef(null);
    const [show, setShow] = useState(true)


    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        };
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues);
        } else {
            form.setFieldsValue(newFormValues);
        }
    };
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {

        setShow(false)
        setTimeout(() => {
            let formValues = null;
            if (propsForm) {
                formValues = propsForm.getFieldsValue();
            } else {
                formValues = form.getFieldsValue();
            }
            console.log({
                formValues
            })
            onFormFinish({
                ...formValues,
            });
        }, 2000);
        setShow(true)

    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
        // propsOnValuesChange(formValues)
    };

    const setFieldValue = (name, value) => {
        if (propsForm) {
            propsForm.setValue(name, value);
        } else {
            form.setValue(name, value);
        }
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }
        return formValues;
    };
    useEffect(() => {
        setDataInitialization();
    }, []);

    useEffect(() => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
    }, [formReloadCount]);
    useEffect(() => {
        // (propsForm ?? form).setFieldsValue({ ...defaultValue })
        setCount((pre)=>pre+1)
    }, [ ])

    return (
        <Row>
            <Col span={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                field={field}
                                // initialValues={initialValues}
                                show={show}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={setFieldValue}
                                setCount={setCount}

                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    field,
    initialValues = {},
    show,
    getAnyFormValue,
    count,
    setFieldValue,
    setCount
}) => {
    return (
        <>
            <Row>
                <Col
                    span={
                        24
                    }
                >
                    <Form.Item
                        labelCol={4}
                        wrapperCol={20}
                        {...field}
                        name={[field?.name ?? '', 'question_and_answer_id']}
                        fieldKey={[field?.fieldKey ?? '', 'question_and_answer_id']}
                        label="question_and_answer_id"
                        initialValue={initialValues?.name}
                        hidden={true}
                    >
                        <div ></div>
                    </Form.Item>
                </Col>
                <Col
                    span={24}
                >
                    <Form.Item
                        labelCol={4}
                        wrapperCol={20}
                        label="標題"
                        name={[field?.name ?? '', 'title']}
                        fieldKey={[field?.fieldKey ?? '', 'title']}
                        initialValue={initialValues?.title}
                        rules={[{ required: true, message: 'Please input name' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        label={
                            "詳細內容"
                        }
                        labelCol={
                            4
                        }
                        wrapperCol={
                            20
                        }
                        fieldKey={[field?.fieldKey ?? '', 'content']}
                        name={[field?.name ?? '', 'content']}

                    >
                        {
                            show ? <Editor
                                // propsValue={
                                //     getAnyFormValue(`${field.name}.more_content`,count)
                                // }
                                // value={getAnyFormValue(
                                //     `${field.name}.more_content`,
                                //     count
                                // )}
                                propsValue={getAnyFormValue(
                                    [field?.name ?? '', 'content'].join('.'),
                                    count
                                )}
                                // name={`${field.name}.more_content`}

                                onContentChange={(
                                    val
                                ) => {
                                    setFieldValue([field?.name ?? '', 'content'].join('.'), val)
                                    setCount(pre => pre + 1)
                                }}
                            /> : <Input />}
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};

const Editor = ({ propsValue = null, onContentChange = () => { }, hidden = false }) => {
    const [form] = Form.useForm();
    const [content, setContent] = useState("");
    const editor = useRef(null);
    const testref = useRef(propsValue)
    const config = {
        // readonly: false, // all options from https://xdsoft.net/jodit/doc/
        // uploader: {
        //     insertImageAsBase64URI: true,
        //     // url: `${axios.defaults.baseURL}/api/literacy/admin/editor/file`
        // },
        // language: 'zh_tw'
        allowResizeTags: false,
        imageDefaultWidth: "100%",
        language: "zh_tw",
        onChangePeriod: 1000,
        i18n: {
            zh_tw: {
                Default: "預設",
                "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.":
                    "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.",
                Anchor: "Anchor",
                Margins: "外邊距（Margins）",
                top: "top",
                right: "right",
                bottom: "bottom",
                left: "left",
                Classes: "Classes",
                Src: "Src",
                Title: "Title",
                Link: "Link",
                file: "file",
                "Image properties": "圖片屬性",
                "Your code is similar to HTML. Keep as HTML?":
                    "你黏貼的文本是一段html代碼，是否保留源格式",
                "Paste as HTML": "html黏貼",
                "Insert as Text": "把html代碼視為普通文本",
                "Error on load list": "加載list錯誤",
                Break: "Pause",
                "No follow": "No follow",
                URL: "URL",
                Crop: "Crop",
                Default: "默認",
                Circle: "圓圈",
                Dot: "點",
                Quadrate: "方形",
                Find: "搜尋",
                "Insert className": "插入標籤名稱",
                "Press Alt for custom resizing": "按Alt自定義調整大小",
                "Find Next": "找下一個",
                "Find Previous": "找上一個",
                replace: "替代",
                "Line height": "行高",
            },
        },
        uploader: {
            insertImageAsBase64URI: false,
            imagesExtensions: ["jpg", "png", "jpeg", "gif", "svg", "webp"],
            url: `${axios.defaults.baseURL}/component/file`, // This won't be used since we're using 
            format: 'json',
            headers: {
                authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
            prepareData: function (formdata) {
                formdata.append('inputFile', formdata.get('files[0]')); // $_POST['name'] on server
                return formdata
            },
            isSuccess: function (resp) {
                return resp.hasOwnProperty('file_id');
            },
            process: function (resp) {
                return {
                    "baseurl": `${axios.defaults.baseURL}/component/file?file_id=${resp?.file_id}`,
                    "messages": [
                        ""
                    ],
                    "files": [
                        ""
                    ],
                    "isImages": [
                        true
                    ],
                    "code": 200
                };
            },
            getMessage: function (resp) {
                return resp.hasOwnProperty('file_id') ? '上傳成功' : '上傳失敗'
            },
        },
    };

    const onChange = (content) => {
        testref.current = content
    };

    useEffect(() => {
        document.body.style.pointerEvents = "auto";
        setContent(propsValue);
    }, [propsValue]);
    useEffect(() => {
        return () => {
            onContentChange(testref.current)
        }
    }, [])
    return (
        <JoditEditor
            propsHidden={hidden}
            ref={editor}
            value={content}
            onChange={(e) => { onChange(e) }}
            config={config}
            tabIndex={1} // tabIndex of textarea
            height={1000}
            allowResizeX={true}
            allowResizeY={true}
        />
    );
};



export default QuestionAndAnswerForm;
